module.exports = __webpack_public_path__ + "img/epoch-lower-left.3e8d6a5d.svg";